import * as React from "react";
const SvgEllipseRadioChecked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 8.5, fill: "white", stroke: "#7625DC", strokeWidth: 7 }));
export default SvgEllipseRadioChecked;
